import axios from "axios";

const uploadToSignedUrl = async (image, fileType, url) => {
  var options = {
    headers: {
      "Content-Type": fileType,
    },
  };

  // const type = file.split(';')[0].split('/')[1]
  const buffer = Buffer.from(
    image.replace(/^data:image\/\w+;base64,/, ""),
    "base64"
  );
  return axios
    .put(url, buffer, options)
    .then((result) => {
      return result.config.url.split("?")[0];
    })
    .catch((error) => {
      console.log(error);
      // alert('ERROR ' + JSON.stringify(error));
    });
};

export default uploadToSignedUrl;
